/**
 * Report export waits until per-chart API slices settle for the active date range.
 */

const CHART_SLICE_KEYS = {
  platformPerformanceComparison: ["socialPerformance"],
  monthlySocialPerformance: ["socialPerformance"],
  socialPerformanceBenchmark: ["competitivePerformance"],
  topPosts: ["topPosts"],
  topStories: ["storyPerformance"],
  campaignPerformance: ["campaignPerformance"],
  optimal_posting_times: ["postHeatmap"],
  paidMediaPerformance: ["paidMediaPerformance"],
  topPerformingAds: ["paidPerformance"],
  topObjectives: ["paidPerformance"],
  topCampaigns: ["paidPerformance"],
  topPaidAds: ["paidPerformance"],
  advertisingPerformance: ["paidPerformance"],
  audienceInsights: ["demographicsFollowers"],
  messages: ["messagesReport"],
  messageSentiment: ["sentimentsReport"],
  alerts: ["alertsReport"],
  timeOfDay: ["messagesTimeOfDay", "alertsTimeOfDay"],
  messageHeatmap: ["messagesHeatmap"],
  socialGoalsOverview: ["ytdPagePerformance"],
  goalPerformance: ["ytdPagePerformance"],
}

export function isReportFetchSettled(slice, fetchKey) {
  if (!slice) return true
  const status = slice.status
  // Idle means the section was never scrolled into view, so the API has not run yet.
  if (status === "idle") return false

  if (fetchKey) {
    if (slice.fetchedFetchKey === fetchKey) {
      return status === "succeeded" || status === "failed"
    }
    if (slice.requestedFetchKey === fetchKey) {
      return status === "succeeded" || status === "failed"
    }
    // Refetch in flight for a new key while older data is still on screen.
    if (status === "loading" && slice.fetchedFetchKey) {
      return true
    }
  }

  if (status === "loading") return false
  return status === "succeeded" || status === "failed"
}

export function createDashboardChartDataReadiness({ selectedClientId, slices, fetchKeys }) {
  if (!selectedClientId) {
    return () => true
  }

  const checkKey = (keyName) => {
    const slice = slices[keyName]
    const fetchKey = fetchKeys[keyName]
    return isReportFetchSettled(slice, fetchKey)
  }

  return (chartId) => {
    const keys = CHART_SLICE_KEYS[chartId]
    if (!keys || !keys.length) return true
    return keys.every((keyName) => checkKey(keyName))
  }
}
